export default __webpack_public_path__ + "static/guitar-player-8e2358e1c88e9e17b3d252c2a52840db.gif";